import { render, staticRenderFns } from "./notifications-container.vue?vue&type=template&id=f539be3c"
import script from "./notifications-container.vue?vue&type=script&lang=js"
export * from "./notifications-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f539be3c')) {
      api.createRecord('f539be3c', component.options)
    } else {
      api.reload('f539be3c', component.options)
    }
    module.hot.accept("./notifications-container.vue?vue&type=template&id=f539be3c", function () {
      api.rerender('f539be3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/settings/notifications/components/notifications-container.vue"
export default component.exports